// frontend/src/components/Dashboard/TrafficSources.jsx - CLEANED
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faSearch,
  faEnvelope,
  faMobileAlt,
  faShoppingCart,
  faUsers,
  faComments,
  faLink,
  faHashtag,
  faShip,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faTwitter,
  faLinkedin,
  faInstagram,
  faYoutube,
  faWhatsapp,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

const SUPPLIER = {
  name: "Mylasha",
  country: "Malaysia",
};

const TrafficSources = ({ sources, userRole, title = "Traffic Sources" }) => {
  const iconMap = {
    direct: faGlobe,
    organic: faSearch,
    social: faFacebook,
    facebook: faFacebook,
    twitter: faTwitter,
    linkedin: faLinkedin,
    instagram: faInstagram,
    whatsapp: faWhatsapp,
    youtube: faYoutube,
    tiktok: faTiktok,
    referral: faLink,
    email: faEnvelope,
    mobile: faMobileAlt,
    web: faShoppingCart,
    users: faUsers,
    chat: faComments,
    hashtag: faHashtag,
    malaysia: faShip,
    supplier: faBuilding,
  };

  const colorMap = {
    direct: "#10b981",
    organic: "#3b82f6",
    social: "#8b5cf6",
    facebook: "#1877f2",
    twitter: "#1da1f2",
    linkedin: "#0a66c2",
    instagram: "#e4405f",
    whatsapp: "#25d366",
    youtube: "#ff0000",
    tiktok: "#000000",
    referral: "#f59e0b",
    email: "#ef4444",
    mobile: "#ec4899",
    web: "#14b8a6",
    users: "#6366f1",
    chat: "#06b6d4",
    hashtag: "#8b5cf6",
    malaysia: "#006B2E",
    supplier: "#D9A321",
  };

  const getDefaultSources = () => {
    if (userRole === "farmer") {
      return [
        {
          name: "direct",
          label: "Direct Visit",
          percentage: 40,
          count: 567,
          color: "#10b981",
        },
        {
          name: "whatsapp",
          label: "WhatsApp",
          percentage: 28,
          count: 398,
          color: "#25d366",
        },
        {
          name: "referral",
          label: "Farmer Referral",
          percentage: 20,
          count: 284,
          color: "#f59e0b",
        },
        {
          name: "organic",
          label: "Organic Search",
          percentage: 12,
          count: 170,
          color: "#3b82f6",
        },
        {
          name: "malaysia",
          label: `${SUPPLIER.country} Direct`,
          percentage: 5,
          count: 71,
          color: "#006B2E",
        },
      ];
    }
    if (userRole === "admin") {
      return [
        {
          name: "direct",
          label: "Direct",
          percentage: 30,
          count: 1245,
          color: "#10b981",
        },
        {
          name: "organic",
          label: "Organic Search",
          percentage: 25,
          count: 1038,
          color: "#3b82f6",
        },
        {
          name: "social",
          label: "Social Media",
          percentage: 20,
          count: 830,
          color: "#8b5cf6",
        },
        {
          name: "referral",
          label: "Referral",
          percentage: 10,
          count: 415,
          color: "#f59e0b",
        },
        {
          name: "email",
          label: "Email",
          percentage: 8,
          count: 332,
          color: "#ef4444",
        },
        {
          name: "malaysia",
          label: `${SUPPLIER.country} Origin`,
          percentage: 7,
          count: 290,
          color: "#006B2E",
        },
      ];
    }
    return [
      {
        name: "direct",
        label: "Direct",
        percentage: 35,
        count: 234,
        color: "#10b981",
      },
      {
        name: "organic",
        label: "Organic Search",
        percentage: 28,
        count: 187,
        color: "#3b82f6",
      },
      {
        name: "social",
        label: "Social Media",
        percentage: 20,
        count: 134,
        color: "#8b5cf6",
      },
      {
        name: "referral",
        label: "Referral",
        percentage: 10,
        count: 67,
        color: "#f59e0b",
      },
      {
        name: "malaysia",
        label: `${SUPPLIER.country} Source`,
        percentage: 7,
        count: 47,
        color: "#006B2E",
      },
    ];
  };

  const data = sources && sources.length > 0 ? sources : getDefaultSources();

  const getIcon = (name) => iconMap[name] || iconMap.direct || faGlobe;
  const getColor = (name) => colorMap[name] || "#6b7280";

  return (
    <div className="traffic-sources">
      <div className="traffic-header">
        <h3>
          <FontAwesomeIcon icon={faGlobe} /> {title}
        </h3>
        <span className="traffic-badge">
          <FontAwesomeIcon icon={faShip} /> {SUPPLIER.country} Sourced
        </span>
      </div>
      <div className="sources-list">
        {data.map((source, index) => {
          const icon = getIcon(source.name);
          const color = source.color || getColor(source.name);
          const percentage = source.percentage || 0;
          const count = source.count || 0;
          const isMalaysia =
            source.name === "malaysia" ||
            source.label?.includes(SUPPLIER.country);

          return (
            <div
              key={index}
              className={`source-item ${isMalaysia ? "malaysia" : ""}`}
            >
              <div className="source-info">
                <div
                  className="source-icon"
                  style={{ background: `${color}15`, color }}
                >
                  <FontAwesomeIcon icon={icon} />
                </div>
                <span className="source-name">
                  {source.label}
                  {isMalaysia && <span className="source-flag">🇲🇾</span>}
                </span>
              </div>
              <div className="source-stats">
                <span className="source-percentage" style={{ color }}>
                  {percentage}%
                </span>
                <div className="source-bar">
                  <div
                    className="source-bar-fill"
                    style={{
                      width: `${Math.min(percentage, 100)}%`,
                      background: color,
                    }}
                  />
                </div>
                <span className="source-count">{count.toLocaleString()}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrafficSources;
